export const data = [
  {
    title: "Из чего формируется конечная стоимость проекта?",
    content: `Являясь всего лишь частью общей картины, непосредственные участники технического прогресса
      призывают нас к новым свершениям, которые, в свою очередь, должны быть своевременно верифицированы.
      Но высококачественный прототип будущего проекта является качественно новой ступенью первоочередных требований. 
      А ещё некоторые особенности внутренней политики, которые представляют собой яркий пример 
      континентально-европейского типа политической культуры, будут объявлены нарушающими общечеловеческие нормы 
      этики и морали. И нет сомнений, что явные признаки победы институционализации призывают нас к новым свершениям, 
      которые, в свою очередь, должны быть указаны как претенденты на роль ключевых факторов. Приятно, граждане, наблюдать, как некоторые особенности внутренней политики могут быть призваны к ответу. Явные признаки победы 
      институционализации набирают популярность среди определенных слоев населения, а значит, должны быть объединены 
      в целые кластеры себе подобных. Банальные, но неопровержимые выводы, а также многие известные личности 
      призывают нас к новым свершениям, которые, в свою очередь, должны быть представлены в исключительно 
      положительном свете.`,
  },
  {
    title:
      "У меня есть свой проект. Сможем ли мы его доработать / реализовать?",
    content: "lorem",
  },
  {
    title: "Я выбираю между разными компаниями. В чём ваше отличие?",
    content: "lorem",
  },
  {
    title:
      "Могу ли я делегировать вам работу / согласование с подрядчиком / организацией? ",
    content: "lorem",
  },
  {
    title: "Могу ли я вернуть деньги на каком-либо из этапов работ?",
    content: "lorem",
  },
];
